import type { PageContext } from 'vike/types'

export function title(pageContext: PageContext) {
    return 'Topela x Pennylane – Guide pas-à-pas'
}